module.exports = __webpack_public_path__ + "static/media/logo-iPEO.faef1452.png";